import { atom } from 'recoil'

export const dateFormatAtom = atom({
  key: 'dateFormat',
  default: 'MMMM do yyyy',
})
